import _ from 'lodash'
import PaginationButton from './pagination-button'
import {
  LeftPaginationButton,
  RightPaginationButton,
} from './end-pagination-button'
import { unique } from '../utils'

type Props = {
  limit: number
  offset: number
  total: number
  page: number
  onChange: (offset: number, page: number) => any
}

export function range(n: number, start: number = 0): number[] {
  const list: number[] = []
  for (let i = start; i < start + n; i++) list.push(i)
  return list
}

function insertSplitter(list: number[]): number[] {
  const ret = [...list]
  for (let i = 0; i < ret.length - 1; i++) {
    if (ret[i + 1] - ret[i] !== 1) {
      ret.splice(i + 1, 0, -1)
      i += 1
    }
  }
  return ret
}

const FIXED_COUNT = 2
const MID_COUNT = 1
export const MAX_PAGE = 600

export function generatePageNumbers(page: number, totalPage: number): number[] {
  const head = range(FIXED_COUNT)
  const mid = range(MID_COUNT * 2 + 1, page - MID_COUNT - 1)
  const foot = range(FIXED_COUNT, Math.min(totalPage, MAX_PAGE) - FIXED_COUNT)

  const list = unique([...head, ...mid, ...foot]).filter(
    (v) => v >= 0 && v < Math.min(totalPage, MAX_PAGE)
  )
  return insertSplitter(list)
}

export const Pagination: React.FC<Props> = (props) => {
  const handleClick = (page: number) => {
    const offset = page * props.limit
    if (props.offset === offset) return
    props.onChange(offset, page)
  }

  const totalPage = Math.ceil(props.total / props.limit)
  const page = props.page

  return (
    <div className="pl-pagination">
      <ul className="pl-pagination-list">
        <LeftPaginationButton
          key="l"
          current={page}
          disabled={page === 1}
          onClick={handleClick}
        />
        {generatePageNumbers(page, totalPage).map((n, i) => (
          <PaginationButton
            key={`${n}-${i}`}
            n={n + 1}
            current={page}
            onClick={handleClick}
          />
        ))}
        <RightPaginationButton
          key="r"
          current={page}
          disabled={page >= Math.min(totalPage, MAX_PAGE)}
          onClick={handleClick}
        />
      </ul>
    </div>
  )
}
